/**
 * HEX 색상 코드를 RGB 배열로 변환합니다.
 * @param {string} hex - '#RRGGBB' 또는 '#RGB' 형식의 HEX 코드
 * @returns {number[]} [R, G, B]
 */
function hexToRgb(hex: string) {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [
    parseInt(result[1], 16),
    parseInt(result[2], 16),
    parseInt(result[3], 16)
  ] : [0, 0, 0];
}

/**
 * 두 색상을 알파 블렌딩 공식으로 혼합합니다.
 * 배경색은 불투명하다고 가정합니다 (알파 1.0).
 *
 * @param {string} backgroundColorHex - 배경색 HEX (#F2F4F6)
 * @param {string} overlayColorHex - 오버레이색 HEX (#000000)
 * @param {number} overlayAlpha - 오버레이 투명도 (0.5)
 * @returns {string | null} 혼합된 최종 색상의 HEX 코드 (#797A7B) 또는 유효하지 않은 경우 null
 */
export const blendColors = (backgroundColorHex: string, overlayColorHex: string, overlayAlpha: number) => {
  const bgRgb = hexToRgb(backgroundColorHex);
  const overlayRgb = hexToRgb(overlayColorHex);
  const alpha = overlayAlpha;

  if (!bgRgb || !overlayRgb) {
    console.error("유효하지 않은 HEX 색상 코드입니다.");
    return null;
  }

  // 알파 블렌딩 공식: C_result = C_source * alpha + C_backdrop * (1 - alpha)
  const finalR = Math.round(overlayRgb[0] * alpha + bgRgb[0] * (1 - alpha));
  const finalG = Math.round(overlayRgb[1] * alpha + bgRgb[1] * (1 - alpha));
  const finalB = Math.round(overlayRgb[2] * alpha + bgRgb[2] * (1 - alpha));

  // 결과를 다시 HEX 형식으로 변환
  const toHex = (c: number) => `00${c.toString(16)}`.slice(-2);
  return `#${toHex(finalR)}${toHex(finalG)}${toHex(finalB)}`.toUpperCase();
};
